import { ApprovalRules, ApprovalStatus, ApprovalStepStatus } from 'ui-product-approvals/types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { useMemo } from 'react';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { jsx as _jsx } from "react/jsx-runtime";
const colorMap = {
  [ApprovalStepStatus.APPROVAL_PENDING]: 'inReview',
  [ApprovalStepStatus.APPROVED]: 'published',
  [ApprovalStepStatus.REJECTED]: 'cancelled'
};
function ApprovalStepStatusText(props) {
  const {
    approvalStepStatus
  } = props;
  const {
    data,
    meta
  } = useApprovalContext();
  const stepIsNotRequired = useMemo(() => data && data.approvalRules === ApprovalRules.ANY_CAN_APPROVE && meta.approvalStatus === ApprovalStatus.APPROVED && approvalStepStatus === ApprovalStepStatus.APPROVAL_PENDING || meta.approvalStatus === ApprovalStatus.REJECTED && approvalStepStatus === ApprovalStepStatus.APPROVAL_PENDING, [data, meta, approvalStepStatus]);
  const approvalStepStatusTextContent = useMemo(() => {
    if (stepIsNotRequired) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStepStatusText.NOT_REQUIRED"
      });
    }
    if (approvalStepStatus === ApprovalStepStatus.APPROVAL_PENDING) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStepStatusText.APPROVAL_PENDING"
      });
    }
    if (approvalStepStatus === ApprovalStepStatus.REJECTED) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStepStatusText.REJECTED"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalStepStatusText.APPROVED"
    });
  }, [approvalStepStatus, stepIsNotRequired]);
  return /*#__PURE__*/_jsx(StatusTag, {
    "data-test-id": "approval-step-status-tag",
    use: stepIsNotRequired ? 'disabled' : colorMap[approvalStepStatus],
    children: approvalStepStatusTextContent
  });
}
export default ApprovalStepStatusText;